/**
 * Application-wide message constants
 */
export class Messages {
  // Currently Used Messages (from existing components)
  static readonly SOMETHING_WENT_WRONG = "Something went wrong";
  static readonly CANCEL_CONFIRMATION = "Are you sure you want to cancel?";
  static readonly CANCEL_CONFIRMATION_BODY =
    "All unsaved changes will be lost. Do you want to proceed?";
  static readonly LOGOUT_CONFIRM_HEADER = "Are you sure you want to log out?";

  // Forecast-specific Messages
  static readonly FORECAST_COMPLETED = "Forecast Completed Successfully";
  static readonly DEMAND_FORECAST_COMPLETED =
    "Demand forecast run started and results will be available in execution history";
  static readonly RETINA_FORECAST_COMPLETED =
    "Retina forecast run started and results will be available in execution history";
  static readonly DRAFT_ORDER_DELETED = "Draft order deleted successfully";
  static readonly DELETE_DRAFT_ORDER_HEADER = "Delete Draft Order";
  static readonly DELETE_DRAFT_ORDER_CONFIRMATION =
    "Are you sure you want to delete this draft order?";
  static readonly DELETE_CONFIRMATION_WARNING = "This action cannot be undone.";
  static readonly DRAFT_ORDER_DETAILS_HEADER = "Draft Order Details";
  static readonly NO_DRAFT_ORDERS_TITLE = "No Draft Orders";
  static readonly NO_DRAFT_ORDERS_DESCRIPTION =
    "Draft orders created from forecasts will appear here. Go to the Forecasts page to run a forecast and create orders.";
  static readonly GO_TO_FORECASTS_LABEL = "Go to Forecasts";
  static readonly DRAFT_ORDERS_PAGE_TITLE = "Draft Orders";
  static readonly DRAFT_ORDERS_PAGE_SUBTITLE =
    "Manage and review draft orders created from forecast results";
  static readonly EXPORT_CSV_LABEL = "Export CSV";
  static readonly FORECAST_FAILED = "Failed to run forecast";
  static readonly NO_DATA_TO_EXPORT = "No data available to export";
  static readonly SELECT_PRACTICE_AND_SITE =
    "Please select both practice and site before running forecast";
  static readonly NO_FORECAST_RESULTS = "No Forecast Results";
  static readonly NO_EXECUTION_HISTORY = "No Execution History";
  static readonly RUN_FIRST_FORECAST =
    "Run your first forecast to see execution history records here";
  static readonly SELECT_PRACTICE_AND_RUN_FORECAST =
    "Select a practice and run a forecast to see results here.";
  static readonly SELECT_PRACTICE_SITE_DATE_RANGE_AND_RUN_FORECAST =
    "Select a practice, site, date range and run a forecast to see results here.";

  // Error Messages
  static readonly UNEXPECTED_ERROR = "An unexpected error occurred";
  static readonly FAILED_CREATE_DRAFT_ORDER = "Failed to create draft order";
  static readonly FAILED_FETCH_DRAFT_ORDERS = "Failed to fetch draft orders";
  static readonly FAILED_DELETE_DRAFT_ORDER = "Failed to delete draft order";
  static readonly FAILED_SAVE_SETTINGS = "Failed to save settings";
  static readonly FAILED_RESET_SETTINGS = "Failed to reset settings";
  static readonly FAILED_LOAD_HISTORICAL_DETAILS =
    "Failed to load historical forecast details. Please try again.";
  static readonly FORECAST_EXECUTION_FAILED =
    "Usage Forecast Execution Failed. Please try after sometime";
  static readonly FAILED_SAVE_SETTINGS_TO_API =
    "Failed to save settings to API";
  static readonly USER_CONTEXT_NOT_AVAILABLE = "User context not available";
  static readonly USER_ID_PRACTICE_ID_NOT_AVAILABLE =
    "User ID or Practice ID not available for loading settings";
  static readonly DEMAND_FORECAST_EXECUTION_FAILED =
    "Demand Forecast Execution Failed. Please try after sometime";
  static readonly RETINA_FORECAST_EXECUTION_FAILED =
    "Retina Forecast Execution Failed. Please try after sometime";
  static readonly DRAFT_ORDER_CREATED_SUCCESS =
    "Draft order created successfully!";
  static readonly AUTO_ORDER_TRIGGERED_SUCCESS =
    "Auto-order triggered successfully!";
  static readonly DRAFT_ORDER_CREATED_LABEL = "Draft Order Created";
  static readonly SETTINGS_SAVED_SUCCESS =
    "Settings saved successfully! Changes will take effect on the next forecast run.";
  static readonly SETTINGS_RESET = "Settings Reset";
  static readonly SETTINGS_RESET_TO_DEFAULTS =
    "Settings have been reset to default values";
  static readonly RESET_ERROR = "Reset Error";
  static readonly CSV_EXPORT_FAILED =
    "CSV Export failed. Please try again later.";
  static readonly EXCEL_EXPORT_FAILED =
    "Excel Export failed. Please try again later.";
  static readonly FAILED_TRIGGER_AUTO_ORDER = "Failed to trigger auto-order";
  static readonly UNEXPECTED_ERROR_SAVING_SETTINGS =
    "An unexpected error occurred while saving settings";

  // Demand Forecast Specific Messages
  static readonly VIEWING_HISTORICAL_RESULTS_FROM =
    "Viewing historical results from:";
  static readonly ORDER_NDC_NOT_FOUND = "Order NDC Not Found";
  static readonly SELECT_TAB_TO_DISPLAY = "Select a Tab to Display";
  static readonly ADD_MORE_TABS = "Add more tabs";
  static readonly NO_FORECAST_ID_FOR_EXPORT =
    "No forecast ID available for export";
  static readonly NO_FORECAST_ID_FOR_TAB_DATA =
    "No forecast ID available for loading tab data";
  static readonly FAILED_LOAD_TAB_DATA = (tabName: string) =>
    `Failed to load ${tabName} data`;
  static readonly INVALID_DATE_RANGE_FORECAST_EXECUTION =
    "Invalid date range for demand forecast execution.";
  static readonly INVALID_DATE_RANGE_FROM_API =
    "Invalid date range received from API.";
  static readonly FAILED_INITIALIZE_DATE_RANGE =
    "Failed to initialize demand forecast date range from API";

  // Unknown/Default Values
  static readonly UNKNOWN_SITE = "Unknown Site";
  static readonly UNKNOWN_PRACTICE = "Unknown Practice";
  static readonly UNKNOWN_DATE = "Unknown Date";
  static readonly UNKNOWN = "Unknown";

  // Message Severity Types
  static readonly ERROR = "Error";
  static readonly SUCCESS = "Success";
  static readonly WARNING = "Warning";
  static readonly INFO = "Info";
}
